import { IOsaModel } from './../../../models/osa-model';
import { Component, OnInit, OnChanges, SimpleChanges, OnDestroy } from "@angular/core";
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { ToastrService } from 'ngx-toastr';
import { OsaService } from 'src/app/services/osa.service';
import { PlanejamentoService } from 'src/app/services/planejamento.service';
import { SharedService } from 'src/app/services/shared.service';
import { BaseFormComponent } from 'src/app/shared/components/base-form/base-form.component';
import Swal from 'sweetalert2';
import { Subscription } from "rxjs";
import { ISalvarAlocarEquipeModel } from "../../../models/alocar-equipe-component";
import { AuthService } from "../../../services/auth.service";

@Component({
  selector: 'app-osa-form',
  templateUrl: './osa-form.component.html',
  styleUrls: ['./osa-form.component.scss']
})
export class OsaFormComponent extends BaseFormComponent implements OnInit, OnDestroy {

  public elaborar = true;
  public numeroOpa: string;
  public osa: any;
  public planejamentoId: number = null;
  public statusOsa: number;
  public model: IOsaModel = {} as IOsaModel;
  public versao: boolean = false;
  public isFilha: boolean = false;
  public emPlanejamento = false;
  private validacaoSubscription: Subscription;
  private aguardandoValidacao = false;
  private processandoGeracaoVersao = false;
  public ocultaSalvar = false;
  private tipoOperacao: 'salvar' | 'gerarVersao' | 'enviarAprovacao' | null = null;
  private salvarEFechar: boolean = false;

  private modelAtualizadoSubscription: Subscription;


  constructor(
    route: ActivatedRoute,
    toastr: ToastrService,
    router: Router,
    localeService: BsLocaleService,
    private planejamentoService: PlanejamentoService,
    public matDialog: MatDialog,
    private osaService: OsaService,
    private sharedService: SharedService,
    private authService: AuthService,
    private activatedRoute: ActivatedRoute,
  ) {
    super(route, toastr, router, localeService, matDialog);
    if (this.elaborar) {
      this.titulo = 'Elaborar OSA';
    }
    if (this.router.url.includes("nova-versao")) {
      this.versao = true;
    }
    this.obterPlanejamentoId();
  }

  ngOnInit(): void {

    this.modelAtualizadoSubscription = this.sharedService.getModelAtualizado().subscribe(
      (modelAtualizado) => {
        this.model = modelAtualizado;
      }
    );

    this.validacaoSubscription = this.sharedService.getValidacaoResponse().subscribe(
      (response) => {
        if (this.aguardandoValidacao) {
          // CORREÇÃO: Verificar o tipo de operação
          switch (this.tipoOperacao) {
            case 'salvar':
              this.processarRespostaValidacao(response);
              break;
            case 'gerarVersao':
              this.processarValidacaoGerarVersao(response);
              break;
            case 'enviarAprovacao':
              this.processarValidacaoEnviarAprovacao(response);
              break;
          }
        }
      }
    );
    const numeroAba = this.activatedRoute.snapshot.queryParamMap.get('aba');
    if (numeroAba) { this.mudarAba(Number(numeroAba)); }
    this.router.url.includes('aba=5') ? this.mudarAba(5) : null;
    this.router.url.includes('aba=6') ? this.mudarAba(6) : null;
  }

  ngOnDestroy(): void {
    if (this.validacaoSubscription) {
      this.validacaoSubscription.unsubscribe();
    }

    if (this.modelAtualizadoSubscription) {
      this.modelAtualizadoSubscription.unsubscribe();
    }
  }

  public mudarAba(e: number) { this.aba = e };

  public obterPlanejamentoId() {
    this.osaService.obterPorId(this.id).then(res => {
      if (res?.dados) {
        this.model = res.dados;
        console.log(res.dados);

        this.statusOsa = res.dados.status.codigo;
        if (this.statusOsa === 4) {
          this.visualizar = true;
        }

        if (this.versao) {
          this.titulo = 'Gerar Nova Versão OSA' + (this.model.numero ? ' - ' + this.model.numero : '');
          this.emPlanejamento = this.model.status.codigo === 4;
        }
        else if (this.visualizar) {
          this.titulo = 'Visualizar OSA' + (this.model.numero ? ' - ' + this.model.numero : '');
        }
        else {
          this.titulo = 'Editar OSA' + (this.model.numero ? ' - ' + this.model.numero : '');
        }


        this.isFilha = this.model?.numero.length > 8;

        this.planejamentoId = res.dados.planejamentoId;
        this.planejamentoService.obterPorId(this.planejamentoId);
        this.ocultaSalvar = this.model?.statusUg?.includes('Subsidiária') || false;

      }
    })
  }

  private processarRespostaValidacao(response: { sucesso: boolean, mensagem?: string }) {
    this.aguardandoValidacao = false;
    this.tipoOperacao = null;

    if (response.sucesso) {
      this.continuarSalvamento();
    } else {
      this.salvarEFechar = false;
      if (response.mensagem) {
        this.exibirMensagemAlerta(response.mensagem);
      }
    }
  }

  private processarValidacaoGerarVersao(response: { sucesso: boolean, mensagem?: string }) {
    this.aguardandoValidacao = false;
    this.tipoOperacao = null;

    if (response.sucesso) {
      this.executarGeracaoNovaVersao();
    } else {
      this.processandoGeracaoVersao = false;
      this.exibirMensagemAlerta(response.mensagem || "Corrija os erros antes de gerar a nova versão");
    }
  }

  private processarValidacaoEnviarAprovacao(response: { sucesso: boolean, mensagem?: string }) {
    this.aguardandoValidacao = false;
    this.tipoOperacao = null;

    if (response.sucesso) {
      this.executarEnvioAprovacao();
    } else {
      this.exibirMensagemAlerta(response.mensagem || "Corrija os erros antes de enviar para aprovação");
    }
  }


  private continuarSalvamento() {
    this.sharedService.sendSalvarEvent();

    setTimeout(() => {
      if (!this.visualizar) {
        // CORREÇÃO: Implementar lógica do salvarEFechar
        if (this.salvarEFechar) {
          this.router.navigate(['/osa']);
        }
      }
    }, 500);
  }


  public async onSalvarOsa(salvarEFechar: boolean = false) {
    try {
      this.aguardandoValidacao = true;
      this.tipoOperacao = 'salvar'; // DEFINIR TIPO
      this.salvarEFechar = salvarEFechar; // ARMAZENAR FLAG

      // Remover subscriber local - usar apenas o global
      this.sharedService.sendValidacaoRequest();

      // Timeout de segurança
      setTimeout(() => {
        if (this.aguardandoValidacao) {
          this.aguardandoValidacao = false;
          this.tipoOperacao = null;
          this.salvarEFechar = false; // RESET
          this.exibirMensagemAlerta('Erro na validação. Verifique os dados e tente novamente.');
        }
      }, 5000);

    } catch (error) {
      this.aguardandoValidacao = false;
      this.tipoOperacao = null;
      this.salvarEFechar = false; // RESET
      console.error('Erro durante o salvamento:', error);
      this.exibirMensagemErro('Erro inesperado durante o salvamento');
    }
  }

  public async gerarNovaVersao() {
    try {
      if (this.processandoGeracaoVersao) {
        this.exibirMensagemAlerta('Aguarde, processando geração de nova versão...');
        return;
      }

      this.processandoGeracaoVersao = true;
      this.aguardandoValidacao = true;
      this.tipoOperacao = 'gerarVersao';

      this.sharedService.sendSincronizarDadosEvent();
      await this.aguardarSincronizacao(500);


      this.sharedService.sendValidacaoRequest();

      setTimeout(() => {
        if (this.aguardandoValidacao) {
          this.aguardandoValidacao = false;
          this.processandoGeracaoVersao = false;
          this.tipoOperacao = null;
          this.exibirMensagemAlerta("Erro na validação para gerar nova versão");
        }
      }, 5000);

    } catch (error) {
      this.aguardandoValidacao = false;
      this.processandoGeracaoVersao = false;
      this.tipoOperacao = null;
      console.error('Erro durante a geração da nova versão:', error);
      this.exibirMensagemErro('Erro inesperado durante a geração da nova versão');
    }
  }

  private aguardarSincronizacao(tempo: number): Promise<void> {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve();
      }, tempo);
    });
  }


  private async executarGeracaoNovaVersao() {
    try {
      this.sharedService.sendSincronizarDadosEvent();

      await this.aguardarSincronizacao(1000);

      const dadosFormulario = this.coletarDadosFormulario();


      const res = await this.osaService.gerarNovaVersao(this.id, dadosFormulario);

      this.processandoGeracaoVersao = false;

      if (res.sucesso) {
        Swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'success',
          text: res.mensagem.descricao,
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        });

        setTimeout(() => {
          this.router.navigate(['/osa']);
        }, 1000);

      } else {
        this.exibirMensagemErro(res.mensagem.descricao);
      }
    } catch (err) {
      this.processandoGeracaoVersao = false;
      this.exibirMensagemErro(err.mensagem?.descricao || 'Erro ao gerar nova versão');
    }
  }
  private coletarDadosFormulario(): any {
    this.sharedService.sendSincronizarDadosEvent();
    const baseData = {
      dataInicioRealizacao: this.model?.dataInicioRealizacao ? new Date(this.model.dataInicioRealizacao) : null,
      dataFimRealizacao: this.model?.dataFimRealizacao ? new Date(this.model.dataFimRealizacao) : null,
      dataConstatacoesPreliminares: this.model?.dataConstatacoesPreliminares ? new Date(this.model.dataConstatacoesPreliminares) : null,
      dataApresentacaoRelatorio: this.model?.dataApresentacaoRelatorio ? new Date(this.model.dataApresentacaoRelatorio) : null,
      qtdeDiasUteisExecucao: this.model?.qtdeDiasUteisExecucao,
      auditorId: this.model?.auditorId,
      notaRodape: this.model?.notaRodape,
      periodoAuditado: this.model?.periodoAuditado,
      statusUg: this.model?.statusUg,
      id: this.id
    };

    let dados = { ...baseData };

    if (this.versao) {
      const dadosEquipe = this.getDadosEquipeParaSalvar();
      if (dadosEquipe) {
        dados = Object.assign(dados, { alocarEquipeOsa: dadosEquipe });

      }
    }
    return dados;
  }

  private getDadosEquipeParaSalvar(): ISalvarAlocarEquipeModel[] | null {
    const dadosSharedService = this.sharedService.getDadosEquipeNovaVersaoValue();
    return dadosSharedService;
  }

  public async enviarParaAprovacao() {
    this.aguardandoValidacao = true;
    this.tipoOperacao = 'enviarAprovacao';

    this.sharedService.sendValidacaoRequest();

    setTimeout(() => {
      if (this.aguardandoValidacao) {
        this.aguardandoValidacao = false;
        this.tipoOperacao = null;
        this.exibirMensagemAlerta("Erro na validação para aprovação");
      }
    }, 5000);
  }

  private async executarEnvioAprovacao() {
    try {

      // if(this.authService.usuario.id !== this.sharedService.getNomeAuditorId()){
      //   this.exibirMensagemAlerta('Apenas o coordenador (informada na aba informação básica) poderão enviar a respectiva OSA para aprovação');
      //   return;
      // }
      const resSubtipos = await this.osaService.obterUgSubTipo(this.model.planejamentoId);
      const osaEquipe = await this.osaService.obterAlocarEquipeOsaId(this.model.id);

      const validacao = this.validarEquipeComUgsVinculadas(resSubtipos.dados, osaEquipe.dados);

      if (!validacao.valido) {
        this.exibirMensagemErro(validacao.mensagem);
        return;
      }


      const res = await this.osaService.enviarAprovacao(this.id, this.planejamentoId);

      if (res.sucesso) {
        Swal.fire({
          toast: true,
          position: 'top-end',
          icon: 'success',
          text: res.mensagem.descricao,
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        });
        this.router.navigate(['/osa']);
      } else {
        //-> Critério 13: retorno de regra de negócio (ex.: "É necessário homologar a OSA
        //-> da UG Principal.") deve ser exibido como ALERTA, não como erro técnico.
        this.exibirMensagemAlerta(res.mensagem.descricao);
      }
    } catch (err) {
      this.exibirMensagemErro(err.mensagem.descricao);
    }
  }

  private validarEquipeComUgsVinculadas(subtipos: any[], equipe: any[]): { valido: boolean, mensagem: string } {
    // Verificar se há membros na equipe
    if (!equipe || equipe.length === 0) {
      return {
        valido: false,
        mensagem: 'A equipe deve ter pelo menos um membro para enviar para aprovação.'
      };
    }

    // Agrupar UGs por statusUG
    const ugsPorStatus = {
      principal: subtipos.filter(st => st.statusUg === 'Principal' || st.statusUg === 'Principal e Consultada'),
      subsidiaria: subtipos.filter(st => st.statusUg === 'Subsidiária' || st.statusUg === 'Subsidiária e Consultada')
    };

    const siglasUgs = subtipos.map(st => st.siglaUg);

    for (const membro of equipe) {
      if (!membro.unidadesVinculadas || membro.unidadesVinculadas.trim() === '') {
        return {
          valido: false,
          mensagem: 'Todos os membros da equipe devem ter uma Unidade Gestora vinculada.'
        };
      }

      const unidadesMembroArray = membro.unidadesVinculadas.split(',').map(u => u.trim());

      const temUgValida = unidadesMembroArray.some(unidadeMembro =>
        siglasUgs.some(sigla => sigla === unidadeMembro)
      );

      if (!temUgValida) {
        return {
          valido: false,
          mensagem: `O membro da equipe possui Unidade Gestora vinculada que não corresponde às UGs da OSA (Principal ou Subsidiária).`
        };
      }
    }


    if (ugsPorStatus.principal.length > 0) {
      const siglasPrincipais = ugsPorStatus.principal.map(ug => ug.siglaUg);
      const temMembroPrincipal = equipe.some(membro => {
        if (!membro.unidadesVinculadas) return false;
        const unidades = membro.unidadesVinculadas.split(',').map(u => u.trim());
        return unidades.some(unidade => siglasPrincipais.includes(unidade));
      });

      if (!temMembroPrincipal) {
        return {
          valido: false,
          mensagem: 'Deve haver pelo menos um membro da equipe vinculado à Unidade Gestora Principal.'
        };
      }
    }

    // Se existem UGs Subsidiárias, deve haver pelo menos um membro vinculado a uma delas
    if (ugsPorStatus.subsidiaria.length > 0) {
      const siglasSubsidiarias = ugsPorStatus.subsidiaria.map(ug => ug.siglaUg);
      const temMembroSubsidiaria = equipe.some(membro => {
        if (!membro.unidadesVinculadas) return false;
        const unidades = membro.unidadesVinculadas.split(',').map(u => u.trim());
        return unidades.some(unidade => siglasSubsidiarias.includes(unidade));
      });

      if (!temMembroSubsidiaria) {
        return {
          valido: false,
          mensagem: 'Deve haver pelo menos um membro da equipe vinculado à Unidade Gestora Subsidiária.'
        };
      }
    }

    return {
      valido: true,
      mensagem: ''
    };
  }
  public onBack() {
    window.history.back()
  }

}
